"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _QuestionAndAnswerPanel = _interopRequireDefault(require("./editorPanel/QuestionAndAnswerPanel"));

var _SmallToggleButton = _interopRequireDefault(require("draft-plugins/components/SmallToggleButton"));

var ToolbarButton = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(ToolbarButton, _React$PureComponent);

  function ToolbarButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ToolbarButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ToolbarButton).call(this, props));
    _this.handleCloseModal = _this.handleCloseModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpenModal = _this.handleOpenModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSave = _this.handleSave.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      open: false
    };
    return _this;
  }

  (0, _createClass2.default)(ToolbarButton, [{
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "handleOpenModal",
    value: function handleOpenModal() {
      this.setState({
        open: true
      });
    }
  }, {
    key: "handleSave",
    value: function handleSave(questionData) {
      var _this2 = this;

      return this.props.saveQuestion(questionData).then(function (question) {
        _this2.props.onInsertQuestionAndAnswerChange(question.questionId);

        return question;
      });
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      var properties = this.props.properties;

      if (!this.state.open) {
        return null;
      }

      var panel = _react.default.createElement(_QuestionAndAnswerPanel.default, {
        saveQuestion: this.handleSave,
        onClose: this.handleCloseModal,
        properties: properties
      }); // Fixes propogation bugs https://git.hubteam.com/HubSpot/composer-lib/commit/7b912974cdc35c6f362a0405d50ffdec9c0eaa58


      return _react.default.Fragment ? _react.default.createElement(_react.default.Fragment, null, panel) : panel;
    }
  }, {
    key: "render",
    value: function render() {
      var disabled = this.props.disabled;
      var open = this.state.open;
      return _react.default.createElement(_SmallToggleButton.default, {
        onClick: this.handleOpenModal,
        active: open,
        disabled: disabled,
        icon: "questionAnswer",
        tooltip: _react.default.createElement(_FormattedMessage.default, {
          message: "composer-lib.insertTools.questionAndAnswer"
        }),
        "data-selenium-test": "insert-q-and-a-button",
        "data-onboarding-id": "insert-q-and-a-button"
      }, this.renderModal());
    }
  }]);
  return ToolbarButton;
}(_react.default.PureComponent);

ToolbarButton.propTypes = {
  disabled: _propTypes.default.bool,
  properties: _propTypes.default.instanceOf(_immutable.Map).isRequired,
  onInsertQuestionAndAnswerChange: _propTypes.default.func.isRequired,
  saveQuestion: _propTypes.default.func.isRequired
};
ToolbarButton.defaultProps = {
  disabled: false
};

var _default = function _default(_ref) {
  var properties = _ref.properties,
      originId = _ref.originId,
      saveQuestion = _ref.saveQuestion;
  return function (props) {
    return _react.default.createElement(ToolbarButton, Object.assign({
      originId: originId,
      properties: properties,
      saveQuestion: saveQuestion
    }, props));
  };
};

exports.default = _default;
module.exports = exports.default;